import {
  LessonPublishUnpublish,
} from "features/lessons/models";
import { axiosClient } from "./client";
import {
  GET_LESSON_BY_ID,
  PACK_LESSON_PUBLISH_UNPUBLISH,
  SINGLE_LESSON_PUBLISH_UNPUBLISH,
  LESSONS_CREATE,
  LESSONS_GET,
  LESSON_PUBLISH_UNPUBLISH,
  GET_LESSON,
  RESERVE_LESSON,
  RESERVED_LESSONS_GET,
  LESSONS_UPDATE,
  TEACHER_GET_LESSON,
} from "./client/endpoints";

const createLessons = async (data: any): Promise<any> => {
  const response = await axiosClient.post<any>(LESSONS_CREATE, data);
  return response.data;
};

const updateLessons = async (data: any): Promise<any> => {
  const response = await axiosClient.post<any>(LESSONS_UPDATE, data);
  return response.data;
};

const getLessons = async (): Promise<any> => {
  const response = await axiosClient.get<any>(LESSONS_GET);
  return response.data;
};

const getReservedLessons = async (): Promise<any> => {
  const response = await axiosClient.get<any>(RESERVED_LESSONS_GET);
  return response.data;
};

const publishUnpublishSingleLesson = async (
  data: LessonPublishUnpublish
): Promise<any> => {
  return await axiosClient.post<any>(SINGLE_LESSON_PUBLISH_UNPUBLISH, data);
};

const publishUnpublishLesson = async (
  data: LessonPublishUnpublish
): Promise<any> => {
  return await axiosClient.post<any>(LESSON_PUBLISH_UNPUBLISH, data);
};

const publishUnpublishPackLesson = async (
  data: LessonPublishUnpublish
): Promise<any> => {
  return await axiosClient.post<any>(PACK_LESSON_PUBLISH_UNPUBLISH, data);
};

// * get lesson by id
const getLessonById = async (data: any): Promise<any> => {
  const res = await axiosClient.post<any>(GET_LESSON_BY_ID, data);
  return res.data.data.data;
};

const getLessonByLessonId = async (data: any): Promise<any> => {
  try {
    const response = await axiosClient.get<any>(`${GET_LESSON}?id=${data}`);
    return response.data;
  } catch (e) {
    return null;
  }
};

const teacherGetLessonByLessonId = async (data: any): Promise<any> => {
  try {
    const response = await axiosClient.get<any>(
      `${TEACHER_GET_LESSON}?id=${data}&type=2`
    );
    return response.data;
  } catch (e) {
    return null;
  }
};

const reserveLesson = async (data: any): Promise<any> => {
  try {
    const response = await axiosClient.post<any>(RESERVE_LESSON, data);
    return response.data;
  } catch (e) {
    return e;
  }
};

const LessonsService = {
  publishUnpublishSingleLesson,
  publishUnpublishPackLesson,
  getLessonById,
  createLessons,
  updateLessons,
  getLessonByLessonId,
  getLessons,
  publishUnpublishLesson,
  reserveLesson,
  getReservedLessons,
  teacherGetLessonByLessonId,
};

export default LessonsService;
